import { c as _c } from "react/compiler-runtime";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@achra/ui/card';
import { cn } from '@achra/ui/lib/utils';
import Image from 'next/image';
import { InternalLink } from '@/modules/shared/components/internal-link';
import type { Route } from 'next';
interface NavigationCardProps {
  image: string;
  title: string;
  description: string;
  href: Route;
  code?: string;
  isCompact: boolean;
  className?: string;
}
function NavigationCard(t0) {
  const $ = _c(43);
  const {
    image,
    title,
    description,
    href,
    code,
    isCompact,
    className
  } = t0;
  const t1 = isCompact ? "p-2" : "p-2 px-4 pb-4";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = cn("bg-popover flex h-full w-full flex-col gap-2 border-none", t1, "xl:p-2 xl:px-4 xl:pb-4", className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("flex flex-col gap-2 p-0", "md:flex-row md:justify-between");
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("relative size-10 overflow-hidden rounded-full", "shadow-primary", "md:size-8", "lg:size-10");
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== image) {
    t5 = <div data-slot="image-wrapper" className={t4}><Image src={image} alt="Budget logo" fill={true} unoptimized={true} /></div>;
    $[5] = image;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== href) {
    t6 = <div className="flex items-center justify-center md:hidden"><InternalLink href={href} className="h-8 w-10 px-2 py-0.5" /></div>;
    $[7] = href;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div data-slot="image-container" className="flex w-full items-center justify-between md:w-fit">{t5}{t6}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = isCompact ? "text-sm/5.5" : "text-base/6";
  let t9;
  if ($[12] !== t8) {
    t9 = cn("overflow-hidden font-semibold text-ellipsis whitespace-nowrap", "text-muted-foreground", t8, "md:self-center");
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== code || $[15] !== t9) {
    t10 = <div data-slot="code" className={t9}>{code}</div>;
    $[14] = code;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t7) {
    t11 = <CardHeader data-slot="header-container" className={t3}>{t7}{t10}</CardHeader>;
    $[17] = t10;
    $[18] = t7;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = isCompact ? "overflow-hidden text-ellipsis whitespace-nowrap" : "lg:text-base lg:leading-6";
  let t13;
  if ($[20] !== t12) {
    t13 = cn("text-base leading-6 font-semibold", t12);
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t13 || $[23] !== title) {
    t14 = <CardTitle data-slot="title" className={t13}>{title}</CardTitle>;
    $[22] = t13;
    $[23] = title;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== description || $[26] !== isCompact) {
    t15 = !isCompact && <CardDescription data-slot="description" className={cn("text-foreground/50 line-clamp-3 text-xs/4.5 font-normal")}>{description}</CardDescription>;
    $[25] = description;
    $[26] = isCompact;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t14 || $[29] !== t15) {
    t16 = <CardContent className="flex flex-1 flex-col gap-1 p-0">{t14}{t15}</CardContent>;
    $[28] = t14;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  const t17 = isCompact && "sm:flex sm:justify-center";
  let t18;
  if ($[31] !== t17) {
    t18 = cn("h-full items-end justify-end md:mt-auto", t17);
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== href) {
    t19 = <InternalLink href={href}>Explore</InternalLink>;
    $[33] = href;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t18 || $[36] !== t19) {
    t20 = <CardFooter className="hidden p-0 md:flex"><div data-slot="button-container" className={t18}>{t19}</div></CardFooter>;
    $[35] = t18;
    $[36] = t19;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== t11 || $[39] !== t16 || $[40] !== t2 || $[41] !== t20) {
    t21 = <Card data-slot="navigation-card" className={t2}>{t11}{t16}{t20}</Card>;
    $[38] = t11;
    $[39] = t16;
    $[40] = t2;
    $[41] = t20;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  return t21;
}
export { NavigationCard };